import React from "react";
import "./MemoryLane.css";
import { HotspotType } from "../../const/fixed/Types";
const videoData = [
  {
    style: { margin: "12% 25%", width: "9%" },
    link: "https://vimeo.com/637463923/13c65fa4b7",
    img: "/assets/images/Memory/1.png",
  },
  {
    style: { margin: "12% 39%", width: "9%" },
    link: "https://vimeo.com/637463552/ad26082c54",
    img: "/assets/images/Memory/2.png",
  },
  {
    style: { margin: "12% 53%", width: "9%" },
    link: "https://vimeo.com/637463435/0652a17858",
    img: "/assets/images/Memory/3.png",
  },
  {
    style: { margin: "12% 67%", width: "9%" },
    link: "https://vimeo.com/637463994/734e099904",
    img: "/assets/images/Memory/4.png",
  },
  {
    style: { margin: "12% 81%", width: "9%" },
    link: "https://vimeo.com/637463770/2239cd3b2f",
    img: "/assets/images/Memory/5.png",
  },
  {
    style: { margin: "25% 21.5%", width: "9%" },
    link: "https://vimeo.com/637464164/5d2115d7c8",
    img: "/assets/images/Memory/6.png",
  },
  {
    style: { margin: "21% 32%", width: "9%" },
    link: "https://vimeo.com/637464936/585415e54b",
    img: "/assets/images/Memory/7.png",
  },
  {
    style: { margin: "25% 41.5%", width: "9%" },
    link: "https://vimeo.com/637465880/b84ff9cfdc",
    img: "/assets/images/Memory/8.png",
  },
  {
    style: { margin: "25% 81%", width: "9%" },
    link: "https://vimeo.com/637466019/407a0445b9",
    img: "/assets/images/Memory/9.png",
  },
  {
    style: { margin: "21% 51.5%", width: "9%" },
    link: "https://vimeo.com/637465516/b406b81859",
    img: "/assets/images/Memory/10.png",
  },
  {
    style: { margin: "25% 61%", width: "9%" },
    link: "https://vimeo.com/637465293/f0e71630e2",
    img: "/assets/images/Memory/11.png",
  },
  {
    style: { margin: "21% 71%", width: "9%" },
    link: "https://vimeo.com/637465128/9a0de1f307",
    img: "/assets/images/Memory/12.png",
  },
  {
    style: { margin: "19% 90%", width: "9%" },
    link: "https://vimeo.com/639028483/94ea780aae",
    img: "/assets/images/Memory/13.png",
  },

  {
    style: { margin: "34% 64%", width: "11%" },
    link: "https://vimeo.com/637464655/d4b32c2d15",
    img: "/assets/images/Memory/14.png",
  },
  {
    style: { margin: "34% 26%", width: "11%" },
    link: "https://vimeo.com/637464142/e0aaab5f89",
    img: "/assets/images/Memory/15.png",
  },
  {
    style: { margin: "34% 44%", width: "11%" },
    link: "https://vimeo.com/637464254/3358303c09",
    img: "/assets/images/Memory/16.png",
  },
];
function MemoryLane({ showMediaModal, hideMemoryLane }) {
  return (
    <div
      className="memory__lane"
      style={{ background: `url(/assets/images/Memory/bg.png) #fff` }}
    >
      <div
        className="m-header"
        onClick={(e) => {
          e.preventDefault();
          hideMemoryLane();
        }}
      >
        <span style={{ background: "#E4CF0E" }}></span>
        <span style={{ background: "#FF7B00" }}></span>
        <span style={{ background: "#445DED" }}></span>
        <img src="/assets/images/Memory/close.svg" alt="" className="close-m" />
      </div>
      <div className="logo-header">
        <img src="/assets/images/Memory/drive.png" alt="" />
        <img src="/assets/images/Memory/logo.png" alt="" />
        <img src="/assets/images/Memory/game-i.png" alt="" />
      </div>
      <div className="m-body">
        <div className="m-left">
          <img src="/assets/images/Memory/body-l.png" alt="" />
        </div>
        <div className="m-right">
          <img src="/assets/images/Memory/lines.png" alt="" className="right" />
          <div className="overlay-i">
            <img
              src="/assets/images/Memory/click.png"
              alt=""
              style={{ margin: "2.5% 46%", width: "24%" }}
            />
            <img
              src="/assets/images/Memory/r-1.png"
              alt=""
              style={{ margin: "12.5% 4%", width: "19%" }}
            />
            <img
              src="/assets/images/Memory/r-2.png"
              alt=""
              style={{ margin: "23% 7%", width: "14%" }}
            />
            <img
              src="/assets/images/Memory/r-3.png"
              alt=""
              style={{ margin: "35% 5%", width: "13%" }}
            />

            {videoData.map((item, pos) => {
              return (
                <img
                  key={pos}
                  style={{ ...item.style }}
                  src={item.img}
                  className="thumnails"
                  onClick={() => {
                    showMediaModal(HotspotType.video, item.link);
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="footer-m">
        <img src="/assets/images/Memory/f-1.png" alt="" />
        <img src="/assets/images/Memory/f-2.png" alt="" />
      </div>
    </div>
  );
}

export default MemoryLane;
